/**
 * Hero (V2) — a PIXEL-PERFECT literal clone of the production reference banner
 * (__reference__/realDemo/landing/components/banner, Phase 11.5.7). ONE component,
 * unchanged public API; the DOM mirrors the reference `<header>` hierarchy exactly with
 * `.sbp-hero*` class names, and the layout is selected purely by a `sbp-hero--<layout>`
 * class (hero.css). Frozen layouts map to the reference banner layouts:
 *   cover → "cover", coverCard → "cover center", split → "card", media → "media".
 *
 * Composed from the shared production primitives (Section, Media, InfoBlock). Assets arrive
 * resolved via the Asset Resolver; theme + RTL come from the Section. The reference banner
 * always renders the info block (hidden by CSS on the "media" layout).
 */
import type { SectionComponentProps } from '../../runtime/types'
import { Section, Media, InfoBlock } from '../shared'
import './hero.css'

export function Hero(p: SectionComponentProps<'hero'>) {
  const { content, layout, id, theme, locale, align, assets } = p

  const item = content.media?.[0]
  const asset = item ? assets.resolve(item.assetId) : null

  const titleId = content.heading ? `${id}-title` : undefined
  const infoAlign = align ?? 'start'

  return (
    <Section
      as="header"
      theme={theme}
      locale={locale}
      id={id}
      flush
      ariaLabelledBy={titleId}
      className={`sbp-hero sbp-hero--${layout}`}
    >
      {item && (
        <div className="sbp-hero__media">
          <Media asset={asset} kind={item.type} alt={content.heading} />
        </div>
      )}
      <div className="sbp-hero__info">
        <div className="sbp-hero__info-content">
          <InfoBlock
            headingLevel={1}
            heading={content.heading}
            subheading={content.subheading}
            actions={content.actions}
            headingId={titleId}
            align={infoAlign}
          />
        </div>
      </div>
    </Section>
  )
}
